import { Branch } from '../base/branch';
import { Type } from './type';

export class Category extends Branch {
    public static _type: string = 'Category';

    public override load(source?: any): void {
        this.copy(source);

        if (source) {
            const { nodes, branches } = source;

            nodes?.forEach((node: any) => {
                this.nodes.push(new Type(node));
            });

            branches?.forEach((branch: any) => {
                this.branches.push(new Category(branch));
            });
        }
    }

    public override fit(branch: Branch): boolean {
        return branch instanceof Category;
    }
}
